module.exports = __webpack_public_path__ + "img/geoffrey-chaouki.8adcd0a.jpeg";